import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';

import { ChannelForm } from '../../components/ChannelForm/ChannelForm';
import { useCloseFormPopup } from '../../hooks/useCloseFormPopup';
import {
  ICreateSpaceChannelPopupParams,
  useCreateSpaceChannelPopupPresenter,
} from './CreateSpaceChannelPopup.presenter';

export const CreateSpaceChannelPopup: FC<ICommonPopupsProps<ICreateSpaceChannelPopupParams>> =
  observer((props) => {
    const { t } = useTranslation();
    const presenter = useCreateSpaceChannelPopupPresenter(props);
    const closeForm = useCloseFormPopup(props, t('cancel_channel_creation_alert'));

    return (
      <Popup
        isOpened
        onClose={closeForm.closePopup}
      >
        <ChannelForm
          title={t('new_channel')}
          initialValues={presenter.initialValues}
          onSubmit={presenter.onSubmit}
          onFormStateChange={closeForm.onFormStateChange}
          onClose={closeForm.closePopup}
        />
      </Popup>
    );
  });
